module.exports = __webpack_public_path__ + "static/img/insure_show.99e3af8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/insure_show.png
// module id = Vkgj
// module chunks = 1